import React from "react";
import { HardHat } from "lucide-react";
import { FOOTER_LINKS } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#1D4ED8] text-white">
                <HardHat className="h-5 w-5" />
              </span>
              <span className="font-display text-xl font-700 text-[#0A2540]">
                cost<span className="text-[#DC2626]">2</span>build<span className="text-[#1D4ED8]">.ai</span>
              </span>
            </div>
            <p className="mt-4 text-slate-600 max-w-xs">
              AI construction cost estimates for the U.S. &amp; Canada — from idea to build-ready scope.
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-slate-500">
              <span className="inline-block h-3 w-5 rounded-sm bg-[#DC2626]" />
              <span className="inline-block h-3 w-5 rounded-sm bg-white border border-slate-300" />
              <span className="inline-block h-3 w-5 rounded-sm bg-[#1D4ED8]" />
              <span className="ml-1">Made for North America</span>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([group, links]) => (
            <div key={group}>
              <h4 className="font-semibold text-[#0A2540]">{group}</h4>
              <ul className="mt-4 space-y-2.5">
                {links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-slate-600 hover:text-[#1D4ED8] transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-slate-200 flex flex-col sm:flex-row justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} cost2build.ai — All rights reserved.</p>
          <p>Estimates are ballpark figures and not a substitute for a licensed contractor quote.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
